import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Measure from 'react-measure';
import { animated, useSpring } from 'react-spring';

import styled from 'styled-components';

import Context from './context';

const Body = ({ children }) => {
  const { on } = useContext(Context);
  const [collapse, setCollapse] = useSpring(() => ({
    height: 0
  }));
  const [fade, setFade] = useSpring(() => ({
    opacity: 0,
    padding: '26px 24px'
  }));

  return (
    <Container style={collapse}>
      <Measure
        bounds
        onResize={contentRect => {
          const { height } = contentRect.bounds;
          setCollapse({
            height: height
          });
          setFade({
            opacity: height ? 1 : 0,
            delay: height ? 200 : 0
          });
        }}
      >
        {({ measureRef }) => (
          <div ref={measureRef}>
            {on && (
              <animated.div style={fade} className="panel-body">
                {children}
              </animated.div>
            )}
          </div>
        )}
      </Measure>
    </Container>
  );
};

Body.propTypes = {
  children: PropTypes.node.isRequired
};

Body.defaultProps = {};

export const PanelBody = React.memo(Body);

const Container = styled(animated.div)`
  border-bottom-left-radius: 2px;
  border-bottom-right-radius: 2px;
`;
